/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TransPb } from "../body/trans";
import {
  InspectionType_Enum,
  inspectionType_EnumFromJSON,
  inspectionType_EnumToJSON,
} from "../surface_scan/inspection_type";
import { PhotoMode_Enum, photoMode_EnumFromJSON, photoMode_EnumToJSON } from "../surface_scan/photo_mode";
import { AwbMode_Enum, awbMode_EnumFromJSON, awbMode_EnumToJSON } from "../user_camera/awb_mode";
import { ExposureMode_Enum, exposureMode_EnumFromJSON, exposureMode_EnumToJSON } from "../user_camera/exposure_mode";
import {
  RecordingMode_Enum,
  recordingMode_EnumFromJSON,
  recordingMode_EnumToJSON,
} from "../user_camera/recording_mode";
import { ScanPhotoStatus_Enum, scanPhotoStatus_EnumFromJSON, scanPhotoStatus_EnumToJSON } from "./scan_photo_status";
import { ScanWaypoint } from "./scan_waypoint";
import {
  TrajectoryActionPlannerFocusState_Enum,
  trajectoryActionPlannerFocusState_EnumFromJSON,
  trajectoryActionPlannerFocusState_EnumToJSON,
} from "./trajectory_action_planner_focus_state";
import {
  TrajectoryActionPlannerPhotoStatus_Enum,
  trajectoryActionPlannerPhotoStatus_EnumFromJSON,
  trajectoryActionPlannerPhotoStatus_EnumToJSON,
} from "./trajectory_action_planner_photo_status";
import {
  TrajectoryActionPlannerStopAtWaypointReason_Enum,
  trajectoryActionPlannerStopAtWaypointReason_EnumFromJSON,
  trajectoryActionPlannerStopAtWaypointReason_EnumToJSON,
} from "./trajectory_action_planner_stop_at_waypoint_reason";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScanPhoto {
  waypoint: ScanWaypoint | undefined;
  status: ScanPhotoStatus_Enum;
  path: string;
  mediaId: string;
  dngPath: string;
  dngMediaId: string;
  photoMode: PhotoMode_Enum;
  utime: number;
  uclock: number;
  awbMode: AwbMode_Enum;
  exposureMode: ExposureMode_Enum;
  recordingMode: RecordingMode_Enum;
  subjectMeanInvRange: number;
  globalMapTPhoto: TransPb | undefined;
  inspectionType: InspectionType_Enum;
  trajectoryActionPlannerPhotoStatus: TrajectoryActionPlannerPhotoStatus_Enum;
  gimbalImuTWaypointRdf: TransPb | undefined;
  gimbalImuStartExpositionTGimbalImuEndExpositionRdf: TransPb | undefined;
  exposureTimeS: number;
  captureSurfacePixelsTravelled: number;
  gimbalImuLinearVelocityLimit: number;
  gimbalImuAngularVelocityLimit: number;
  stopAtWaypoint: boolean;
  stopAtWaypointReason: TrajectoryActionPlannerStopAtWaypointReason_Enum;
  minVehicleToGimbalPitch: number;
  maxGimbalRoll: number;
  maxGimbalRollRate: number;
  ispPhotoRequestUtime: number;
  ispPhotoCaptureUtime: number;
  ispInProgressExposedUtime: number;
  ispReadyForNextUtime: number;
  ispCaptureSuccessfulUtime: number;
  ispCaptureFailedUtime: number;
  focusConvergenceTimeS: number;
  focusStateAtEnqueue: TrajectoryActionPlannerFocusState_Enum;
}

function createBaseScanPhoto(): ScanPhoto {
  return {
    waypoint: undefined,
    status: 0,
    path: "",
    mediaId: "",
    dngPath: "",
    dngMediaId: "",
    photoMode: 0,
    utime: 0,
    uclock: 0,
    awbMode: 0,
    exposureMode: 0,
    recordingMode: 0,
    subjectMeanInvRange: 0,
    globalMapTPhoto: undefined,
    inspectionType: 0,
    trajectoryActionPlannerPhotoStatus: 0,
    gimbalImuTWaypointRdf: undefined,
    gimbalImuStartExpositionTGimbalImuEndExpositionRdf: undefined,
    exposureTimeS: 0,
    captureSurfacePixelsTravelled: 0,
    gimbalImuLinearVelocityLimit: 0,
    gimbalImuAngularVelocityLimit: 0,
    stopAtWaypoint: false,
    stopAtWaypointReason: 0,
    minVehicleToGimbalPitch: 0,
    maxGimbalRoll: 0,
    maxGimbalRollRate: 0,
    ispPhotoRequestUtime: 0,
    ispPhotoCaptureUtime: 0,
    ispInProgressExposedUtime: 0,
    ispReadyForNextUtime: 0,
    ispCaptureSuccessfulUtime: 0,
    ispCaptureFailedUtime: 0,
    focusConvergenceTimeS: 0,
    focusStateAtEnqueue: 0,
  };
}

export const ScanPhoto = {
  encode(message: ScanPhoto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      ScanWaypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.path !== "") {
      writer.uint32(26).string(message.path);
    }
    if (message.mediaId !== "") {
      writer.uint32(98).string(message.mediaId);
    }
    if (message.dngPath !== "") {
      writer.uint32(90).string(message.dngPath);
    }
    if (message.dngMediaId !== "") {
      writer.uint32(114).string(message.dngMediaId);
    }
    if (message.photoMode !== 0) {
      writer.uint32(120).int32(message.photoMode);
    }
    if (message.utime !== 0) {
      writer.uint32(32).sint64(message.utime);
    }
    if (message.uclock !== 0) {
      writer.uint32(40).sint64(message.uclock);
    }
    if (message.awbMode !== 0) {
      writer.uint32(48).int32(message.awbMode);
    }
    if (message.exposureMode !== 0) {
      writer.uint32(56).int32(message.exposureMode);
    }
    if (message.recordingMode !== 0) {
      writer.uint32(104).int32(message.recordingMode);
    }
    if (message.subjectMeanInvRange !== 0) {
      writer.uint32(69).float(message.subjectMeanInvRange);
    }
    if (message.globalMapTPhoto !== undefined) {
      TransPb.encode(message.globalMapTPhoto, writer.uint32(74).fork()).ldelim();
    }
    if (message.inspectionType !== 0) {
      writer.uint32(80).int32(message.inspectionType);
    }
    if (message.trajectoryActionPlannerPhotoStatus !== 0) {
      writer.uint32(128).int32(message.trajectoryActionPlannerPhotoStatus);
    }
    if (message.gimbalImuTWaypointRdf !== undefined) {
      TransPb.encode(message.gimbalImuTWaypointRdf, writer.uint32(138).fork()).ldelim();
    }
    if (message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf !== undefined) {
      TransPb.encode(message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf, writer.uint32(146).fork()).ldelim();
    }
    if (message.exposureTimeS !== 0) {
      writer.uint32(153).double(message.exposureTimeS);
    }
    if (message.captureSurfacePixelsTravelled !== 0) {
      writer.uint32(161).double(message.captureSurfacePixelsTravelled);
    }
    if (message.gimbalImuLinearVelocityLimit !== 0) {
      writer.uint32(169).double(message.gimbalImuLinearVelocityLimit);
    }
    if (message.gimbalImuAngularVelocityLimit !== 0) {
      writer.uint32(177).double(message.gimbalImuAngularVelocityLimit);
    }
    if (message.stopAtWaypoint === true) {
      writer.uint32(184).bool(message.stopAtWaypoint);
    }
    if (message.stopAtWaypointReason !== 0) {
      writer.uint32(256).int32(message.stopAtWaypointReason);
    }
    if (message.minVehicleToGimbalPitch !== 0) {
      writer.uint32(193).double(message.minVehicleToGimbalPitch);
    }
    if (message.maxGimbalRoll !== 0) {
      writer.uint32(201).double(message.maxGimbalRoll);
    }
    if (message.maxGimbalRollRate !== 0) {
      writer.uint32(209).double(message.maxGimbalRollRate);
    }
    if (message.ispPhotoRequestUtime !== 0) {
      writer.uint32(264).sint64(message.ispPhotoRequestUtime);
    }
    if (message.ispPhotoCaptureUtime !== 0) {
      writer.uint32(216).sint64(message.ispPhotoCaptureUtime);
    }
    if (message.ispInProgressExposedUtime !== 0) {
      writer.uint32(224).sint64(message.ispInProgressExposedUtime);
    }
    if (message.ispReadyForNextUtime !== 0) {
      writer.uint32(232).sint64(message.ispReadyForNextUtime);
    }
    if (message.ispCaptureSuccessfulUtime !== 0) {
      writer.uint32(240).sint64(message.ispCaptureSuccessfulUtime);
    }
    if (message.ispCaptureFailedUtime !== 0) {
      writer.uint32(248).sint64(message.ispCaptureFailedUtime);
    }
    if (message.focusConvergenceTimeS !== 0) {
      writer.uint32(273).double(message.focusConvergenceTimeS);
    }
    if (message.focusStateAtEnqueue !== 0) {
      writer.uint32(280).int32(message.focusStateAtEnqueue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanPhoto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanPhoto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = ScanWaypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.path = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.mediaId = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.dngPath = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.dngMediaId = reader.string();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.photoMode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.uclock = longToNumber(reader.sint64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.awbMode = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.exposureMode = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.recordingMode = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.subjectMeanInvRange = reader.float();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.globalMapTPhoto = TransPb.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.inspectionType = reader.int32() as any;
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.trajectoryActionPlannerPhotoStatus = reader.int32() as any;
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.gimbalImuTWaypointRdf = TransPb.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf = TransPb.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 153) {
            break;
          }

          message.exposureTimeS = reader.double();
          continue;
        case 20:
          if (tag !== 161) {
            break;
          }

          message.captureSurfacePixelsTravelled = reader.double();
          continue;
        case 21:
          if (tag !== 169) {
            break;
          }

          message.gimbalImuLinearVelocityLimit = reader.double();
          continue;
        case 22:
          if (tag !== 177) {
            break;
          }

          message.gimbalImuAngularVelocityLimit = reader.double();
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.stopAtWaypoint = reader.bool();
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.stopAtWaypointReason = reader.int32() as any;
          continue;
        case 24:
          if (tag !== 193) {
            break;
          }

          message.minVehicleToGimbalPitch = reader.double();
          continue;
        case 25:
          if (tag !== 201) {
            break;
          }

          message.maxGimbalRoll = reader.double();
          continue;
        case 26:
          if (tag !== 209) {
            break;
          }

          message.maxGimbalRollRate = reader.double();
          continue;
        case 33:
          if (tag !== 264) {
            break;
          }

          message.ispPhotoRequestUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 27:
          if (tag !== 216) {
            break;
          }

          message.ispPhotoCaptureUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 28:
          if (tag !== 224) {
            break;
          }

          message.ispInProgressExposedUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.ispReadyForNextUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.ispCaptureSuccessfulUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 31:
          if (tag !== 248) {
            break;
          }

          message.ispCaptureFailedUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 34:
          if (tag !== 273) {
            break;
          }

          message.focusConvergenceTimeS = reader.double();
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.focusStateAtEnqueue = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanPhoto {
    return {
      waypoint: isSet(object.waypoint) ? ScanWaypoint.fromJSON(object.waypoint) : undefined,
      status: isSet(object.status) ? scanPhotoStatus_EnumFromJSON(object.status) : 0,
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      mediaId: isSet(object.mediaId) ? globalThis.String(object.mediaId) : "",
      dngPath: isSet(object.dngPath) ? globalThis.String(object.dngPath) : "",
      dngMediaId: isSet(object.dngMediaId) ? globalThis.String(object.dngMediaId) : "",
      photoMode: isSet(object.photoMode) ? photoMode_EnumFromJSON(object.photoMode) : 0,
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uclock: isSet(object.uclock) ? globalThis.Number(object.uclock) : 0,
      awbMode: isSet(object.awbMode) ? awbMode_EnumFromJSON(object.awbMode) : 0,
      exposureMode: isSet(object.exposureMode) ? exposureMode_EnumFromJSON(object.exposureMode) : 0,
      recordingMode: isSet(object.recordingMode) ? recordingMode_EnumFromJSON(object.recordingMode) : 0,
      subjectMeanInvRange: isSet(object.subjectMeanInvRange) ? globalThis.Number(object.subjectMeanInvRange) : 0,
      globalMapTPhoto: isSet(object.globalMapTPhoto) ? TransPb.fromJSON(object.globalMapTPhoto) : undefined,
      inspectionType: isSet(object.inspectionType) ? inspectionType_EnumFromJSON(object.inspectionType) : 0,
      trajectoryActionPlannerPhotoStatus: isSet(object.trajectoryActionPlannerPhotoStatus)
        ? trajectoryActionPlannerPhotoStatus_EnumFromJSON(object.trajectoryActionPlannerPhotoStatus)
        : 0,
      gimbalImuTWaypointRdf: isSet(object.gimbalImuTWaypointRdf)
        ? TransPb.fromJSON(object.gimbalImuTWaypointRdf)
        : undefined,
      gimbalImuStartExpositionTGimbalImuEndExpositionRdf:
        isSet(object.gimbalImuStartExpositionTGimbalImuEndExpositionRdf)
          ? TransPb.fromJSON(object.gimbalImuStartExpositionTGimbalImuEndExpositionRdf)
          : undefined,
      exposureTimeS: isSet(object.exposureTimeS) ? globalThis.Number(object.exposureTimeS) : 0,
      captureSurfacePixelsTravelled: isSet(object.captureSurfacePixelsTravelled)
        ? globalThis.Number(object.captureSurfacePixelsTravelled)
        : 0,
      gimbalImuLinearVelocityLimit: isSet(object.gimbalImuLinearVelocityLimit)
        ? globalThis.Number(object.gimbalImuLinearVelocityLimit)
        : 0,
      gimbalImuAngularVelocityLimit: isSet(object.gimbalImuAngularVelocityLimit)
        ? globalThis.Number(object.gimbalImuAngularVelocityLimit)
        : 0,
      stopAtWaypoint: isSet(object.stopAtWaypoint) ? globalThis.Boolean(object.stopAtWaypoint) : false,
      stopAtWaypointReason: isSet(object.stopAtWaypointReason)
        ? trajectoryActionPlannerStopAtWaypointReason_EnumFromJSON(object.stopAtWaypointReason)
        : 0,
      minVehicleToGimbalPitch: isSet(object.minVehicleToGimbalPitch)
        ? globalThis.Number(object.minVehicleToGimbalPitch)
        : 0,
      maxGimbalRoll: isSet(object.maxGimbalRoll) ? globalThis.Number(object.maxGimbalRoll) : 0,
      maxGimbalRollRate: isSet(object.maxGimbalRollRate) ? globalThis.Number(object.maxGimbalRollRate) : 0,
      ispPhotoRequestUtime: isSet(object.ispPhotoRequestUtime) ? globalThis.Number(object.ispPhotoRequestUtime) : 0,
      ispPhotoCaptureUtime: isSet(object.ispPhotoCaptureUtime) ? globalThis.Number(object.ispPhotoCaptureUtime) : 0,
      ispInProgressExposedUtime: isSet(object.ispInProgressExposedUtime)
        ? globalThis.Number(object.ispInProgressExposedUtime)
        : 0,
      ispReadyForNextUtime: isSet(object.ispReadyForNextUtime) ? globalThis.Number(object.ispReadyForNextUtime) : 0,
      ispCaptureSuccessfulUtime: isSet(object.ispCaptureSuccessfulUtime)
        ? globalThis.Number(object.ispCaptureSuccessfulUtime)
        : 0,
      ispCaptureFailedUtime: isSet(object.ispCaptureFailedUtime) ? globalThis.Number(object.ispCaptureFailedUtime) : 0,
      focusConvergenceTimeS: isSet(object.focusConvergenceTimeS) ? globalThis.Number(object.focusConvergenceTimeS) : 0,
      focusStateAtEnqueue: isSet(object.focusStateAtEnqueue)
        ? trajectoryActionPlannerFocusState_EnumFromJSON(object.focusStateAtEnqueue)
        : 0,
    };
  },

  toJSON(message: ScanPhoto): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = ScanWaypoint.toJSON(message.waypoint);
    }
    if (message.status !== 0) {
      obj.status = scanPhotoStatus_EnumToJSON(message.status);
    }
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.mediaId !== "") {
      obj.mediaId = message.mediaId;
    }
    if (message.dngPath !== "") {
      obj.dngPath = message.dngPath;
    }
    if (message.dngMediaId !== "") {
      obj.dngMediaId = message.dngMediaId;
    }
    if (message.photoMode !== 0) {
      obj.photoMode = photoMode_EnumToJSON(message.photoMode);
    }
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uclock !== 0) {
      obj.uclock = Math.round(message.uclock);
    }
    if (message.awbMode !== 0) {
      obj.awbMode = awbMode_EnumToJSON(message.awbMode);
    }
    if (message.exposureMode !== 0) {
      obj.exposureMode = exposureMode_EnumToJSON(message.exposureMode);
    }
    if (message.recordingMode !== 0) {
      obj.recordingMode = recordingMode_EnumToJSON(message.recordingMode);
    }
    if (message.subjectMeanInvRange !== 0) {
      obj.subjectMeanInvRange = message.subjectMeanInvRange;
    }
    if (message.globalMapTPhoto !== undefined) {
      obj.globalMapTPhoto = TransPb.toJSON(message.globalMapTPhoto);
    }
    if (message.inspectionType !== 0) {
      obj.inspectionType = inspectionType_EnumToJSON(message.inspectionType);
    }
    if (message.trajectoryActionPlannerPhotoStatus !== 0) {
      obj.trajectoryActionPlannerPhotoStatus = trajectoryActionPlannerPhotoStatus_EnumToJSON(
        message.trajectoryActionPlannerPhotoStatus,
      );
    }
    if (message.gimbalImuTWaypointRdf !== undefined) {
      obj.gimbalImuTWaypointRdf = TransPb.toJSON(message.gimbalImuTWaypointRdf);
    }
    if (message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf !== undefined) {
      obj.gimbalImuStartExpositionTGimbalImuEndExpositionRdf = TransPb.toJSON(
        message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf,
      );
    }
    if (message.exposureTimeS !== 0) {
      obj.exposureTimeS = message.exposureTimeS;
    }
    if (message.captureSurfacePixelsTravelled !== 0) {
      obj.captureSurfacePixelsTravelled = message.captureSurfacePixelsTravelled;
    }
    if (message.gimbalImuLinearVelocityLimit !== 0) {
      obj.gimbalImuLinearVelocityLimit = message.gimbalImuLinearVelocityLimit;
    }
    if (message.gimbalImuAngularVelocityLimit !== 0) {
      obj.gimbalImuAngularVelocityLimit = message.gimbalImuAngularVelocityLimit;
    }
    if (message.stopAtWaypoint === true) {
      obj.stopAtWaypoint = message.stopAtWaypoint;
    }
    if (message.stopAtWaypointReason !== 0) {
      obj.stopAtWaypointReason = trajectoryActionPlannerStopAtWaypointReason_EnumToJSON(message.stopAtWaypointReason);
    }
    if (message.minVehicleToGimbalPitch !== 0) {
      obj.minVehicleToGimbalPitch = message.minVehicleToGimbalPitch;
    }
    if (message.maxGimbalRoll !== 0) {
      obj.maxGimbalRoll = message.maxGimbalRoll;
    }
    if (message.maxGimbalRollRate !== 0) {
      obj.maxGimbalRollRate = message.maxGimbalRollRate;
    }
    if (message.ispPhotoRequestUtime !== 0) {
      obj.ispPhotoRequestUtime = Math.round(message.ispPhotoRequestUtime);
    }
    if (message.ispPhotoCaptureUtime !== 0) {
      obj.ispPhotoCaptureUtime = Math.round(message.ispPhotoCaptureUtime);
    }
    if (message.ispInProgressExposedUtime !== 0) {
      obj.ispInProgressExposedUtime = Math.round(message.ispInProgressExposedUtime);
    }
    if (message.ispReadyForNextUtime !== 0) {
      obj.ispReadyForNextUtime = Math.round(message.ispReadyForNextUtime);
    }
    if (message.ispCaptureSuccessfulUtime !== 0) {
      obj.ispCaptureSuccessfulUtime = Math.round(message.ispCaptureSuccessfulUtime);
    }
    if (message.ispCaptureFailedUtime !== 0) {
      obj.ispCaptureFailedUtime = Math.round(message.ispCaptureFailedUtime);
    }
    if (message.focusConvergenceTimeS !== 0) {
      obj.focusConvergenceTimeS = message.focusConvergenceTimeS;
    }
    if (message.focusStateAtEnqueue !== 0) {
      obj.focusStateAtEnqueue = trajectoryActionPlannerFocusState_EnumToJSON(message.focusStateAtEnqueue);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanPhoto>, I>>(base?: I): ScanPhoto {
    return ScanPhoto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanPhoto>, I>>(object: I): ScanPhoto {
    const message = createBaseScanPhoto();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? ScanWaypoint.fromPartial(object.waypoint)
      : undefined;
    message.status = object.status ?? 0;
    message.path = object.path ?? "";
    message.mediaId = object.mediaId ?? "";
    message.dngPath = object.dngPath ?? "";
    message.dngMediaId = object.dngMediaId ?? "";
    message.photoMode = object.photoMode ?? 0;
    message.utime = object.utime ?? 0;
    message.uclock = object.uclock ?? 0;
    message.awbMode = object.awbMode ?? 0;
    message.exposureMode = object.exposureMode ?? 0;
    message.recordingMode = object.recordingMode ?? 0;
    message.subjectMeanInvRange = object.subjectMeanInvRange ?? 0;
    message.globalMapTPhoto = (object.globalMapTPhoto !== undefined && object.globalMapTPhoto !== null)
      ? TransPb.fromPartial(object.globalMapTPhoto)
      : undefined;
    message.inspectionType = object.inspectionType ?? 0;
    message.trajectoryActionPlannerPhotoStatus = object.trajectoryActionPlannerPhotoStatus ?? 0;
    message.gimbalImuTWaypointRdf =
      (object.gimbalImuTWaypointRdf !== undefined && object.gimbalImuTWaypointRdf !== null)
        ? TransPb.fromPartial(object.gimbalImuTWaypointRdf)
        : undefined;
    message.gimbalImuStartExpositionTGimbalImuEndExpositionRdf =
      (object.gimbalImuStartExpositionTGimbalImuEndExpositionRdf !== undefined &&
          object.gimbalImuStartExpositionTGimbalImuEndExpositionRdf !== null)
        ? TransPb.fromPartial(object.gimbalImuStartExpositionTGimbalImuEndExpositionRdf)
        : undefined;
    message.exposureTimeS = object.exposureTimeS ?? 0;
    message.captureSurfacePixelsTravelled = object.captureSurfacePixelsTravelled ?? 0;
    message.gimbalImuLinearVelocityLimit = object.gimbalImuLinearVelocityLimit ?? 0;
    message.gimbalImuAngularVelocityLimit = object.gimbalImuAngularVelocityLimit ?? 0;
    message.stopAtWaypoint = object.stopAtWaypoint ?? false;
    message.stopAtWaypointReason = object.stopAtWaypointReason ?? 0;
    message.minVehicleToGimbalPitch = object.minVehicleToGimbalPitch ?? 0;
    message.maxGimbalRoll = object.maxGimbalRoll ?? 0;
    message.maxGimbalRollRate = object.maxGimbalRollRate ?? 0;
    message.ispPhotoRequestUtime = object.ispPhotoRequestUtime ?? 0;
    message.ispPhotoCaptureUtime = object.ispPhotoCaptureUtime ?? 0;
    message.ispInProgressExposedUtime = object.ispInProgressExposedUtime ?? 0;
    message.ispReadyForNextUtime = object.ispReadyForNextUtime ?? 0;
    message.ispCaptureSuccessfulUtime = object.ispCaptureSuccessfulUtime ?? 0;
    message.ispCaptureFailedUtime = object.ispCaptureFailedUtime ?? 0;
    message.focusConvergenceTimeS = object.focusConvergenceTimeS ?? 0;
    message.focusStateAtEnqueue = object.focusStateAtEnqueue ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
